module.exports = __webpack_public_path__ + "static/media/rigCompressed.be120894.jpg";